import { VueModule } from '@Foundation/utilities';
import MySkinSos from './code/Scripts/components/MySkinSos';

export default VueModule({
  components: {
    MySkinSos
  }
});
